module.exports = __webpack_public_path__ + "static/media/INFORMES-DE-ENVIO.48aa9d17.png";